export default "__VITE_ASSET__DhXUdOKT__"